// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"82411668","238":"24919be1","321":"c7d79ba9"}[chunkId] + ".chunk.js";
};